import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useCableSubscription } from './useCableSubscription';
import { transcriptKeys } from '../../../hooks/transcripts/queries';
import { useRefreshTranscriptAICoding } from '../../../hooks/ai_coding/queries';
import { isCurrentSession } from '../../../utils/SessionIDUtil';

/**
 * TranscriptCable component for handling transcript-related cable events
 */
function TranscriptCable({ projectId }) {
  const queryClient = useQueryClient();
  const refreshTranscriptAICoding = useRefreshTranscriptAICoding();

  const handleTranscriptCable = useCallback((response) => {
    // Skip processing if this response is from the current session
    if (response.session_id && isCurrentSession(response.session_id)) {
      return;
    }

    const action = response['action'];

    if (action === 'create' || action === 'update' || action === 'destroy') {
      // For any transcript changes, invalidate transcript lists and counts to refresh
      queryClient.invalidateQueries({
        queryKey: transcriptKeys.lists()
      });
      queryClient.invalidateQueries({
        queryKey: transcriptKeys.counts()
      });
    } else if (action === 'job') {
      refreshTranscriptAICoding(response?.job?.transcript_id);
    }
  }, [queryClient, projectId, refreshTranscriptAICoding]);

  useCableSubscription({
    channel: { channel: 'TranscriptsChannel', project: projectId },
    onReceived: handleTranscriptCable
  });

  return null;
}

export default TranscriptCable;